export const initialBuilderData = {
    name: '',
    section: {
        ids: [],
        entries: {},
    },
    column: {},
    component: {},
    selected: null,
    selectedType: '',
};

export const initialBuilderPageInfo = {
    pageName: null,
    pageTitle: null,
    slug: null,
    meta: {
        description: null,
        keywords: null,
        image: null,
        imageInfo: { _id: null, filePath: null },
    },
    renderType: 'builder',
    isHomePage: false,
};

export const builderStructureData = (type, mode, bid) => {

    const builderData = {
        page: {
            name: 'page',
            type: 'FE_PAGE',
            mode: mode,
            builderId: bid,
            adminType: 'CA',
        },
        blog: {
            name: 'blog',
            type: 'FE_BLOG',
            mode: mode,
            builderId: bid,
            adminType: 'CA',
        },
        header: {
            name: 'header',
            type: 'FE_HEADER',
            mode: mode,
            builderId: bid,
            adminType: 'CA',
        },
        footer: {
            name: 'footer',
            type: 'FE_FOOTER',
            mode: mode,
            builderId: bid,
            adminType: 'CA',
        },
        popup: {
            name: 'modal',
            type: 'FE_MODAL',
            mode: mode,
            builderId: bid,
            adminType: 'CA',
        },
        'page-template': {
            name: 'page-template',
            type: 'SA_PAGE_TEMPLATE',
            mode: mode,
            builderId: bid,
            adminType: 'SA',
        },
        default: {
            type: 'FE_PAGE',
            mode: mode,
            builderId: bid,
            adminType: 'SA',
        },
    };
    return builderData[type];
};
